import { useQuery } from '@tanstack/react-query';

import { productApi } from '../api/productApi';

export function useProfileProduct() {
  const { data: profilesData, isLoading: isLoadingProfiles } = useQuery({
    queryKey: ['profiles'],
    queryFn: async () => {
      const data = await productApi.getProfiles();

      return data;
    },
  });

  return {
    profilesData,
    isLoadingProfiles,
  };
}
